import { ChevronDown } from 'lucide-react';

export const FilterSelectIcon = (props: { className?: string }) => (
  <ChevronDown size={16} className={props.className} />
);
